package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_08_04_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-08-04")
@Composable
public fun Log_2023_08_04(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Ambush of the Venom Trolls",
        ogTitle = "Ambush of the Venom Trolls",
        date = LocalDate(2_023, 8, 4),
        ogDescription = "The heroes are ambushed by Goblinoids and Venom Trolls in an overgrown ruin, leading to a chaotic, bloody battle.",
        ogImage = "ai/2023-08-04.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
        Log_2023_08_04_Day_1()
    }
}
